// start:ng42.barrel
export * from './button-loader.component';
// end:ng42.barrel
